import { headerConstants } from "../_constants";

export function header(state = {}, action) {
  switch (action.type) {
  case headerConstants.PAGE_DASHBOARD:
    return {
      ...state,
      currentPage: "dashboard"
    };
  case headerConstants.PAGE_NOTES:
    return {
      ...state,
      currentPage: "notes"
    };
  case headerConstants.PAGE_ALERTS:
    return {
      ...state,
      currentPage: "alerts"
    };
  case headerConstants.PAGE_DEVICES:
    return {
      ...state,
      currentPage: "devices"
    };
  case headerConstants.PAGE_REPORTS:
    return {
      ...state,
      currentPage: "reports"
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/header.reducer.js